import { ApplicationConfig, ErrorHandler } from '@angular/core';

import { createErrorHandler } from './error-handler';
import { loaderScript } from './loader';

import type { SentryConfig } from './sentry-config.type';
import type { SentryClient } from './type';

declare const Sentry: SentryClient | undefined;

let config: SentryConfig | undefined;

export const initSentry = (configuration: SentryConfig) => {
  config = configuration;

  if (!configuration.dsn) {
    return;
  }

  window.sentryOnLoad = function () {
    const { dsn, tracesSampleRate, sampleRate, allowedUrls, environmentName, release, ignoreErrors } = configuration;

    Sentry?.init({
      dsn,
      release,
      environment: environmentName,

      sampleRate,
      tracesSampleRate,

      allowUrls: [
        new RegExp(window.location.hostname),
        new RegExp('^https://www.googletagmanager.com'),
        ...allowedUrls.map((url) => new RegExp(url)),
      ],
      ignoreErrors: [
        'Event `ErrorEvent` captured as exception with message `Script error.`',
        ...ignoreErrors.map((error) => new RegExp(error)),
      ],
    });
  };

  const script = document.createElement('script');
  script.textContent = loaderScript(configuration.dsn);
  script.type = 'text/javascript';
  document.head.appendChild(script);
};

export const setupAngularSentry = (appConfig: ApplicationConfig): ApplicationConfig => {
  if (!config || !config.dsn) {
    return appConfig;
  }

  appConfig.providers.push({
    provide: ErrorHandler,
    useValue: createErrorHandler(),
  });

  return appConfig;
};
